import React from 'react';
import * as R from 'ramda';
import Box from '@mui/material/Box';
//import styles from './css/ApplyPaymentToInvoices.scss';
import { invoicePayObject } from '../../lib/utils/schema';
import * as Yup from 'yup';
import {
	MaskedInputRHF,
	DateRHF,
	DropDownRHF,
	FormCardRHF,
	BaseRHF
} from '@cd/rhf';
import useApplyPayment from './../fetch/useApplyPayment';

const PAYMENT_TYPES = [
	{ id: 102, name: 'CHECK' },
	{ id: 103, name: 'M/O' }
];

const SCHEMA = Yup.object().shape(invoicePayObject);

const sumSelectedAmount = R.compose(
	R.reduce(R.add, 0),
	R.map(v => +v),
	R.pluck('amount')
);

const pluckInvoiceIDs = R.pluck('id');

const ApplyPaymentToInvoices = ({ selected }) => {
	const { mutate } = useApplyPayment();
	const record = {
		amount: sumSelectedAmount(selected),
		type: 102,
		paymentDate: new Date()
	};

	return (
		<Box component="div">
			<FormCardRHF
				mode="all"
				schema={SCHEMA}
				ignoreDirty
				onSubmit={values =>
					mutate({
						...values,
						invoiceIDs: pluckInvoiceIDs(selected)
					})
				}
				title="APPLY PAYMENT"
				subtitle="PAY FOR INVOICES"
				okButtonTitle="PAY"
				defaultValues={record}>
				<BaseRHF
					name="type"
					label="Type"
					render={props => (
						<DropDownRHF options={PAYMENT_TYPES} {...props} />
					)}
				/>
				<BaseRHF
					name="amount"
					label="Amount"
					render={props => (
						<MaskedInputRHF mask={Number} {...props} />
					)}
				/>

				<DateRHF
					margin="normal"
					name="paymentDate"
					label="Payment Date"
				/>
			</FormCardRHF>
		</Box>
	);
};

export default ApplyPaymentToInvoices;
